/**
 * Created by roman.kupin on 10/3/2017.
 */



export const NAME = "ftCarouselCardsMoveLeft";

export const DEFINITION = [function () {
    return {
        scope: false,
        require: "^ftCarouselCards",
        link: function (scope, elem, attrs, ctrl) {

            const cardsCtrl = ctrl;

            function move() {
                scope.$apply(() => {
                    if(cardsCtrl.activeCardIndex > 0) {
                        cardsCtrl.moveLeft();
                    }
                });
            }

            elem.bind("click", move);

            scope.$on("$destroy", () => {
                elem.unbind("click", move);
            });
        }
    };
}];

